<template>
  <div class="pb-cont">
    <v-container class="pb-cont elevation-2 pa-0">
      <v-col>
        <v-row class="pb-title-cont">
          <span class="pb-title white--text">
            {{ title }}
          </span>
        </v-row>
        <v-row class="pb-content" justify="end" align="center">
          <v-container class="pa-0">
            <v-row justify="center" align="center">
              <v-col align="center" class="pb-icon">
                <v-icon color="black" large>
                  {{ icon }}
                </v-icon>
              </v-col>

              <v-col align="center" class="pb-value">
                <div>
                  <v-icon color="red">
                    mdi-thermometer-high
                  </v-icon>
                </div>
                <div class="">
                  {{ temp_max }} °C
                </div>
              </v-col>

              <v-col align="center" class="pb-value">
                <v-icon color="blue">
                  mdi-thermometer-low
                </v-icon>
                <div class="">
                  {{ temp_min }} °C
                </div>
              </v-col>

              <v-col align="center" class="pb-value">
                <v-icon>
                  mdi-weather-pouring
                </v-icon>
                <div class="">
                  {{ rain }} %
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-col>
    </v-container>
  </div>
</template>

<script>
 /* import { mapState, mapActions, mapMutations } from 'vuex'; */

 export default {
   name: 'InfoBox',

   props: [
     'title',
     'icon',
     'temp_min',
     'temp_max',
     'rain',
   ],

   data: () => ({
     //
   }),

   methods: {
   },
 };
</script>

<style>
 .pb-cont {
   width: 26em;
   display: inline-box;
   border-radius: 5px;
 }

 .pb-title-cont {
   border-radius: 5px 5px 0px 0px;
   background-color: #880016 !important;
   padding: .4em 1em .4em 1em;
 }

 .pb-title {
   font-size: 1em;
 }

 .pb-icon {
 }

 .pb-value {
   flex-grow: 2;
 }

 .pb-content {
   border-radius: 0px 0px 5px 5px;
   background-color: #edc4cb;
   padding-left: 1em;
   padding-right: 1em;
   height: 4em;
   font-size: 1.2em;
 }
</style>
